import React, {useState}  from "react";
import { Link } from "react-router-dom";
import { SHOW_COLLABORATORS } from "../config";
import './header.css';

const Header = () => {


    const [bar, setBar] = useState();

    return (
        <div bar={bar} className="header">
            <div className="logo">
                <img className="logo-icon" src="./TS.png" alt="Tim Schneider logo" />
                <span className="logo-text logo-text-highlighted">Tim Ph</span>
                <span className="logo-text logo-text">illip</span>
                &nbsp;
                <span className="logo-text logo-text-highlighted">S</span>
                <span className="logo-text logo-text">chneider</span>
                <span className="logo-text logo-text-highlighted">.de</span>
            </div>
            <div className="menu-items">
                <span><Link className="menu-item" to="/">Home</Link></span>
                <span><Link className="menu-item" to="/about">About Me</Link></span>
                <span><Link className="menu-item" to="/cv">CV</Link></span>
                {SHOW_COLLABORATORS &&
                    <span><Link className="menu-item" to="/collaborators">Collaborators</Link></span>}
            </div>
            
        </div>
    )
};


export default Header